import { useQuery } from 'react-query'
import useAuthRedirectQueries from '../queries/authRedirectQueries'
import { ResourceType } from 'features/common'

export function useCheckMapAccess(mapId: string) {
  const { queries } = useAuthRedirectQueries(ResourceType.Map, mapId)
  return useQuery(queries.checkMapAccess)
}

export function useCheckWorkflowAccess(workflowId: string) {
  const { queries } = useAuthRedirectQueries(ResourceType.Workflow, workflowId)
  return useQuery(queries.checkWorkflowAccess)
}
